import HomePageLayout from 'global/HomePageLayout';
import { Container } from './styled';
import NotFound from './index';

const GuestNotFound = () => (
  <HomePageLayout>
    <Container>
      <NotFound />
    </Container>
  </HomePageLayout>
);

export default GuestNotFound;
